<template>
    <div class="job-monitor-overlay" v-if="jobMonitor && !jobMonitor.end_at && !jobMonitor.error_at">
        <div class="progress">
            <div class="progress-bar" role="progressbar" :aria-valuenow="jobMonitor.progress" aria-valuemin="0" aria-valuemax="100"
                 :style="{width: jobMonitor.progress + '%'}">
                {{jobMonitor.progress}}%
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            jobMonitor: {
                type: Object,
            },
        },

        computed: {
            //Override
            progress(){
                if( this.jobMonitor ){
                    return this.jobMonitor.progress;
                }
            },
        },

        methods: {}
    }
</script>
